import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class SettingsRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel() {
		document.body.id = 'page-account';

		return this.navigationService.initialRequestsPromise;
	}
}
